/**
 *
 * 转账或者截图处 上传图片
 * 与聊天时的上传图片区分开
 */

import utils from "../utils";
import store from "src/app/customer/store";
export default {
  data() {
    return {
      uploadApi: "/api/common/s3/upload",
      limit: 5,
      accept: "image/jpeg,image/jpg,image/png,image/gif,image/webp",
      headers: {},
      params: { folderType: 0 },
      listObj: {},
      fileList: [],
      imgQuality: 0.7,
      canClick: true,
      isUpload: false //是否正在上传
    };
  },
  computed: {
    ...mapState({
      isConversation: state => state.isConversation
    }),
    buttonDisablie: {
      //控制完成，进入客服按钮能否点击
      get: function() {
        return this.fileList.length || this.isCheck;
      },
      set: function(newValue) {
        return newValue;
      }
    }
  },
  created() {
    //初始化状态
    this.fileList = [];
    this.listObj = {};
    if (
      utils.isCustomer() &&
      store.state.domain &&
      store.state.domain.API_URL
    ) {
      this.uploadApi = store.state.domain.API_URL + "/api/common/s3/upload";
    } else {
      this.uploadApi =
        process.env.VUE_APP_CUST_BASEURL + "api/common/s3/upload";
    }
  },
  mounted() {
    const headerData = utils.getRequestHeader();
    this.headers = { ...headerData };
    this.dragUploadImg();
  },
  methods: {
    handleSuccess(response = {}, file) {
      console.log(response, file);
      this.canClick = true;
      const {
        name,
        uid,
        url,
        response: { data }
      } = file;

      if (response.code == 200) {
        // let time = null;
        console.log("上传成功");
        this.listObj[uid] = data[0].url;
        const addFocusEventInput = document.querySelector(".addFocusEvent");
        addFocusEventInput && addFocusEventInput.focus();
        this.isUpload = false;
        // this.fileList.push({ name, uid, url });
        let obj = { name, uid, url };
        this.fileList = JSON.stringify([...this.fileList, obj]);
        // clearTimeout(time);
        // // 防止弱网环境只执行一次成功回调
        // time = setTimeout(() => {
        //   this.fileList.push({ name, uid, url });
        // }, 500);
      } else {
        if (response.code == "306") {
          this.isUpload = false;
          this.fileList = this.fileList.filter(s => s.uid != uid);
          this.$message.error(response.msg);
          return false;
        }
        this.isUpload = false;
        this.fileList = this.fileList.filter(s => s.uid != uid); //服务器上传失败 移除
        this.$message.error("上传失败! 请重新上传！");
      }
    },
    handleRemove(file) {
      const uid = file.uid;
      delete this.listObj[uid];
      this.fileList = this.fileList.filter(s => s.uid != uid); //移除
      if (this.hideUploadEdit) {
        this.removeImg();
      }
    },
    beforeUpload(file) {
      var that = this;
      this.canClick = false;
      return new Promise((resolve, reject) => {
        const isJPEG = file.type === "image/jpeg";
        const isJPG = file.type === "image/jpg";
        const isPNG = file.type === "image/png";
        const isGIF = file.type === "image/gif";
        const isWEBP = file.type === "image/webp";
        const isLt1M = file.size / 1024 / 1024 < 1;
        const isLt10M = file.size / 1024 / 1024 > 10;
        let bool = false;
        if (isJPG || isPNG || isJPEG || isGIF || isWEBP) {
          //判断是否符合格式要求
          bool = true;
        } else {
          this.$store.commit("setState", {
            isMsgUpload: false
          });
          this.$message.closeAll();
          that.$message.error("上传文件必须是jpg、png、jpeg、gif、webp格式!");
          this.canClick = true;
          reject(false);
        }
        if (isLt10M) {
          this.isUpload = false;
          this.$message.error("图片太大,请压缩后上传");
          reject(false);
        }
        console.log(bool, !isLt1M, isLt10M);
        if (bool && !isLt1M && isLt10M) {
          //如果格式符合要求，但是size过大，对图片进行处理
          let image = new Image(),
            resultBlob = "";
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            resultBlob = that.compressUpload(image); //Blob
            this.isUpload = true;
            resolve(resultBlob);
          };
        } else if (bool && isLt1M) {
          this.isUpload = true;
          resolve(file); //file
        }
      });
    },
    handleExceed() {
      this.$message.error(`图片数量超出限制，最多上传${this.limit}张`);
    },
    handleError() {
      // this.imgload=false;
      this.isUpload = false;
      this.$message.warning("上传失败");
    },
    compressUpload(image) {
      let canvas = document.createElement("canvas"); //创建画布元素
      let ctx = canvas.getContext("2d");
      let { width } = image,
        { height } = image;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      let compressData = canvas.toDataURL("image/jpeg", 0.5); //等比压缩
      let blobImg = this.dataURItoBlob(compressData); //base64转Blob
      return blobImg;
    },
    dataURItoBlob(data) {
      let byteString;
      if (data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(data.split(",")[1]); //转二进制
      } else {
        byteString = unescape(data.split(",")[1]);
      }
      let mimeString = data
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    // 拖拽上传
    dragUploadImg() {
      const body = document.body;
      body.addEventListener("dragenter", e => {
        e.preventDefault();
      });

      body.addEventListener("dragover", e => {
        e.preventDefault();
      });

      body.addEventListener("drop", e => {
        e.stopPropagation();
        e.preventDefault();
        if (!this.isConversation) {
          return false;
        }
        var files = e.dataTransfer.files; //获取文件
        console.log(files);
      });
    }
  }
};
